import { type PresentationFiltersResponse, getPresentationFiltersFn } from "../common/openapi";

import type { UseFullQueryOptions } from "./react-query";

export const queryPresentationFilters = ((presentationOrViewUrn: undefined | string) => ({
	queryKey: ["presentation-filters", presentationOrViewUrn] as const,
	queryFn: () => getPresentationFiltersFn({ presentationOrViewUrn: presentationOrViewUrn! }),
	enabled: presentationOrViewUrn != null,
})) satisfies (presentationOrViewUrn: undefined | string) => UseFullQueryOptions<PresentationFiltersResponse, Error>;
